export enum ReportTypes {
  AccountsSummary = 'AccountsSummary',
  ChartAndDetails = 'ChartAndDetails',
  MultiDataset = 'MultiDataset',
  Other = 'Other'
}
